import { BILLING_ADDRESS_SCOPE } from '../../../../../constants/billing'
import { StreetInstruction } from './StreetInstruction'

export class BillingStreetInstruction extends StreetInstruction {
  constructor ({ label, waitForNoLoaders, value }) {
    super({ label, waitForNoLoaders, value })
    this.name = 'BillingStreet'
    this.scope = BILLING_ADDRESS_SCOPE
  }

  setDefaultValue (params) {
    this.value = this.retrieveStreetFromAddress(params.billingInformation.address)
  }
}
